import NoEndorsementData from './NoEndorsementData';
import { Row, Col, Tabs, Icon, Tooltip } from 'antd';
import { ssDateUtils } from '@bit/ui-common.ui-components/ss-utils';

const 
{ TabPane } = Tabs,
{ unixSecondsToTimestampString } = ssDateUtils;

class NoDataIndicator extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div className='provider-endrosement-email-no-data' style={{ display: 'inline-block' }}>
                {'(none)'}
            </div>
        )
    }
}

class Email extends React.Component {
    constructor(props) { super(props); }

    buildEmailElements = str => {
        let elements = null;

        try {
            // TODO
            // This logic is based on the recipient format being:
            // fn ln<email>;fn ln<email>;...
            // This may have to change according to the requirements,
            // which will be asked about later.
            elements = str.split(';')
            .filter(e => 
                e != null && 
                e !== '' && 
                e.indexOf('<') !== -1 && 
                e.indexOf('>') !== -1)
            .map(e => ({ 
                name: e.substring(0, e.indexOf('<')), 
                email: e.substring(e.indexOf('<') + 1, e.indexOf('>')) 
            }))
            .filter(e => 
                e.email !== '' && 
                e.email != null
            );
        } catch(err) { elements = []; }
        
        if (elements.length === 0) {
            if (str.length > 0) return str;
            else return <NoDataIndicator />;
        } else return elements.map((e, i) => (
            <Tooltip key={i} title={e.email === 'null' ? 'No address' : e.email}>
                <div className='provider-endorsement-email-address-element'>
                    {e.name}
                </div>
            </Tooltip>
        ));
    }

    render() {
        const 
        { data, type, lastElement, firstElement } = this.props,
        styles = { margin: `${
            lastElement ? '10px 0px 0px' 
            : firstElement ? '0px 0px 10px' 
            : '10px 0px'
        }`};

        switch(type) {
            case 'cc': return (
                <div style={styles}>
                    <div className='provider-endorsement-email-header-element'>
                        {'Cc'}
                    </div>
                    <div className='provider-endorsement-email-header-data'>
                        {data === '' || data == null ? <NoDataIndicator /> : (
                            <div className='provider-endrosement-email-header-data-container'>
                                {'data'}
                            </div>
                        )}
                    </div>
                </div>
            );

            case 'recipients': return (
                <div style={styles}>
                    <div className='provider-endorsement-email-header-element'>
                        {'Recipients'}
                    </div>
                    <div className='provider-endorsement-email-header-data'>
                        {data === '' || data == null ? <NoDataIndicator /> : (
                            <div className='provider-endrosement-email-header-data-container'>
                                {this.buildEmailElements(data)}
                            </div>
                        )}
                    </div>
                </div>
            );

            case 'subject': return (
                <div style={styles}>
                    <div className='provider-endorsement-email-header-element'>
                        {'Subject'}
                    </div>
                    <div className='provider-endorsement-email-header-data'>
                        {data === '' || data == null ? <NoDataIndicator /> : (
                            <div className='provider-endrosement-email-header-data-container'>
                                {data}
                            </div>
                        )}
                    </div>
                </div>
            );

            default: return null;
        }
    }
}

export default class EndorsementData extends React.Component {
    constructor(props) { super(props); }
    render() {
        const 
        { endorsements, email } = this.props,
        { requests } = endorsements;

        if (email.metaRequest.loading ) return (
            <div className='provider-endorsements-loading-container'>
                <Icon 
                    type='loading' 
                    style={{ fontSize: '20px' }}
                />
                <span className='provider-endorsements-loading'>
                    {'Fetching data...'}
                </span>
            </div>
        );
        return email.meta == null || email.meta.length === 0 ? <NoEndorsementData/> : (
            <Row>
                <Col span={24}>
                    <Tabs>
                        {email.meta.filter(item => item.dateSent !== null).map((e, i) => (
                            <TabPane tab={(
                                <div>
                                    <Icon type='mail' style={{ marginRight: '7px' }} />
                                    {e.subject}
                                </div>
                            )} key={e.emailId + ''}>
                                <div className='provider-endorsement-email-timestamp-container'>
                                    <div className='provider-endorsement-email-timestamp'>
                                        <Icon type='clock-circle' style={{ marginRight: '6px' }} />
                                        <span>
                                            {'Sent: '}
                                        </span>
                                        {unixSecondsToTimestampString(e.dateSent)}
                                    </div>
                                </div>
                                <div className='provider-endrosement-email-header'>
                                    <Email type='cc' data={e.cc} firstElement />
                                    <Email type='recipients' data={e.recipients} />
                                    <Email type='subject' data={e.subject} lastElement />
                                </div>
                                <div className='provider-endorsement-email-outer'>
                                    <div 
                                        className='provider-endorsement-email-container'
                                        style={{ maxHeight: Math.round(window.innerHeight * 0.5) }}
                                    >
                                        {email.data[i] == null || !email.data[i].hasOwnProperty('content') ? null 
                                            : (
                                                <div className='provider-endorsement-email-body'>
                                                    {email.data[i].content.split('\n').map((e, i) => (
                                                        <div key={i} className='provider-endorsement-email-div'>
                                                            {e}
                                                        </div>
                                                    ))}
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </TabPane>
                        ))}
                    </Tabs>
                </Col>
            </Row>
        );
    }
}